import { map, defaultTo } from 'ramda'

const defaultToEmptyArray = defaultTo([])

const Select = ({ props: { defaultValue, disabled, multiple, emptyOption}, slots, data }) => (
	<select
		domPropsDisabled={ disabled }
		domPropsMultiple={ multiple }
		{ ...data }
	>
		{emptyOption &&
			<option></option>
		}

		{ map(({ tag, data: { domProps = {}, ...data }, children }) => (
			h(
				tag,
				{
					domProps: {
						...domProps,
						selected: domProps.value === defaultValue || Array.isArray(defaultValue) && defaultValue.includes(domProps.value),
					},
					...data,
				},
				children
			)
		), defaultToEmptyArray(slots().default)) }
	</select>
);

Select.props = {
	defaultValue: [String, Array],
	disabled: Boolean,
	multiple: Boolean,
	emptyOption: Boolean,
}

const Option = ({ props: { value, disabled }, slots }) => (
	<option value={ value } disabled={ disabled }>
		{ slots().default }
	</option>
);

Option.props = {
	value: String,
	disabled: Boolean,
}

export {
	Select as default,
	Option
};
